import React, { useRef, useEffect, useCallback } from 'react';
import { Field } from 'react-final-form';
import FormInput from 'Shared/components/FormComponents/FormInput';
import useAfterTypingSubmit from 'Shared/utils/use-after-typing-submit';

import './index.scss';
import { WpIcon } from 'Wpds/components/icon';

type Props = {
  name: string;
  onSubmit: Function;
};

export default function SearchInput({ name, onSubmit }: Props) {
  const ref = useRef<HTMLInputElement>(null);

  const { onKeyDown } = useAfterTypingSubmit({ onSubmit, debounce: 300 });

  const handleKeyDown = useCallback(
    event => {
      if (['Backspace', 'Enter'].includes(event.key)) onKeyDown(event);
    },
    [onKeyDown]
  );

  useEffect(() => {
    if (ref.current) ref.current.focus();
  }, []);

  return (
    <div className="d-flex w-100 align-items-center px-3 search-module-input">
      <Field
        innerRef={ref}
        name={name}
        icon={
          <span className="search-module-input-icon">
            <WpIcon name="search" />
          </span>
        }
        onKeyDown={handleKeyDown}
        onKeyPress={onKeyDown}
        component={FormInput}
        cleared
      />
    </div>
  );
}
